"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("preact/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
var hooks_1 = require("preact/hooks");
var button_1 = __importDefault(require("../generator/components/button"));
var translations_1 = __importDefault(require("../common/translations"));
var file_picker_1 = __importDefault(require("../generator/components/file-picker"));
var EmbedCTA = function (props) {
    var country = props.country, docType = props.docType, language = props.language, styled = props.styled, onChange = props.onChange, _a = props.cta, cta = _a === void 0 ? (0, translations_1.default)("cta") : _a, loading = props.loading;
    var isLoading = loading.value;
    var classes = (0, classnames_1.default)({
        'bg-yellow hover:bg-yellow-dark px-6 text-center font-bold z-10 shadow-md': !!styled
    });
    var pickerRef = (0, hooks_1.useRef)(null);
    var openFilePicker = function () {
        var _a;
        (_a = pickerRef.current) === null || _a === void 0 ? void 0 : _a.openFilePicker();
    };
    var generatorPath = 'generatorPath' in window ? window.generatorPath : 'free-biometric-photo-generator';
    var handleFileChange = function (file) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            onChange(country, docType, file);
            return [2 /*return*/];
        });
    }); };
    var finalCta = cta || (0, translations_1.default)("cta");
    var href = "/".concat(language).concat(generatorPath, "?country=").concat(country, "&doc=").concat(docType);
    return (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(file_picker_1.default, { loading: isLoading, onChange: handleFileChange, ref: pickerRef }), (0, jsx_runtime_1.jsx)(button_1.default, __assign({ href: href, styled: styled, class: classes, onClick: openFilePicker }, { children: isLoading ? (0, translations_1.default)("loading") : finalCta }))] });
};
exports.default = EmbedCTA;
